import NewLayout from "@components/new-ui/Layout";
import React from "react";
import { CasestudyCard, casestudyCards } from ".";
import { CaseStudyHerosection, CaseStudyInformation, ClientFeedback, FeatureList, Navbar, navLinks, OrganizationProfile } from "./alrannan-administrative-services";
import StatsInfo from "@components/new-ui/IndustriesSection/StatsInfo";

const Mrmed: React.FC = () => {
    return (
        <NewLayout
            title="MrMed Increases Customer Retention on WhatsApp with Gallabox"
            description=" Read how MrMed trusts Gallabox as a leader in WhatsApp automation solutions for the healthcare industry."
            canonical="https://gallabox.com/case-study/mrmed"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/case-study/mrmed/mrmed-og.png" }}
        >
            <CaseStudyHerosection
                title="MrMed enhances retention and support with WhatsApp automation"
                imageUrl={"https://assets.gallabox.com/gb-home/case-study/mrmed/mrmed-hero.png"}
                redirectUrl={"/case-study"}
            />
            <StatsInfo
                statsInfo={[
                    { percentage: "30%", label: "increase in lead generation" },
                    { percentage: "10%", label: "improvement in first-time conversion" },
                    { percentage: "15%", label: "increase in employee productivity" },
                ]}
            />

            <section className="max-w-7xl mx-auto  md:grid md:grid-cols-6 mt-24 mb-24">
                <div className="bg-white col-span-1">
                    <div style={{ position: "sticky", top: "100px" }}>
                        <OrganizationProfile
                            companyProfileData={[
                                { label: "Category", value: ["Healthcare"] },
                                { label: "Location", value: ["India"] },
                            ]}
                            product={{
                                title: "Features Used",
                                productLink: [
                                    { link: "https://gallabox.com/whatsapp-broadcast", label: "WhatsApp Broadcast" },
                                    { link: "https://gallabox.com/whatsapp-chatbot", label: "Whatsapp Chatbot" },
                                    { link: "https://gallabox.com/whatsapp-drip-marketing", label: "Drip Marketing" },
                                    { link: "https://gallabox.com/whatsapp-flows", label: "WhatsApp Flows" },
                                    { link: "https://gallabox.com/whatsapp-shared-inbox", label: "Shared team Inbox" },
                                    { link: "https://gallabox.com/whatsapp-integrations", label: "Integrations" },
                                ],
                            }}
                        />
                    </div>
                </div>
                <div className=" col-span-4 md:pl-8 px-4">
                    <div className="flex flex-col gap-y-12 ">
                        <section id="About">
                            <p>
                                <a href="https://www.mrmed.in/" className="text-blue-500">
                                    MrMed
                                </a>
                                is an Indian online pharmacy specializing in super-specialty medicines, aiming to make life-saving treatments more accessible and affordable across
                                the country. Headquartered in Chennai, it was founded in 2020 by Devashish Singh and Saurab Jain in response to the challenges patients faced in
                                accessing critical medications during the COVID-19 pandemic.
                            </p>
                        </section>

                        <section id="Challenges">
                            <CaseStudyInformation subTitle={"The challenge"} className="gap-6" />

                            <p>
                                In the highly sensitive and time-critical world of healthcare, MrMed was struggling with a critical gap — no WhatsApp support for customers. “We
                                were using Freshchat, but it had serious limitations that affected how we connected with patients,” shared Laksh Chhajer, Founder’s Office at MrMed.
                            </p>
                        </section>

                        <section id="Solutions">
                            <CaseStudyInformation subTitle={"The search for a better solution"} />
                            <p>
                                The team explored alternatives like WATI and Rasayel, but none struck the right balance between functionality and affordability. That’s when
                                Gallabox stood out.
                            </p>
                            <p className="mt-5">“Gallabox was the most cost-effective platform that also ticked all the right boxes for us,” Laksh noted.</p>
                            <CaseStudyInformation subTitle={"Why Gallabox?"} />
                            <p className="mt-5">For MrMed, Gallabox offered a robust set of tools to:</p>
                            <p className="mt-5">
                                Unlike many tools that charge a premium for automation and integrations, Gallabox provided MrMed.in with a full suite of features at a price point
                                that made sense for a fast-growing startup. “We didn’t want to overpay for basic functionality—Gallabox gave us value for every rupee,” said Laksh.
                            </p>

                            <CaseStudyInformation subTitle={"Cost-effectiveness without compromising power"} />
                            <p className="mt-5">
                                Unlike many tools that charge a premium for automation and integrations, Gallabox provided MrMed.in with a full suite of features at a price point
                                that made sense for a fast-growing startup. “We didn’t want to overpay for basic functionality—Gallabox gave us value for every rupee,” said Laksh.
                            </p>
                            <CaseStudyInformation subTitle={"Automation at scale"} />
                            <p className="mt-5">
                                With built-in chatbots and WhatsApp flows, MrMed.in was able to automate lead capture, customer onboarding, and FAQs. This freed up the support team
                                to focus on more critical issues, improving response time and reducing manual effort.
                            </p>
                            <CaseStudyInformation subTitle={"Seamless customer communication"} />
                            <p className="mt-5">
                                Gallabox’s Shared Team Inbox centralized all WhatsApp conversations, enabling customer service reps to work collaboratively. This reduced delays,
                                ensured continuity, and helped deliver a consistent experience across every interaction.
                            </p>
                            <CaseStudyInformation subTitle={"Retention-focused features"} />
                            <p className="mt-5">
                                Using Drip Marketing Campaigns and Broadcasts, the team at MrMed.in re-engaged dormant customers, sent timely health reminders, and promoted new
                                offers—driving both retention and repeat orders.
                            </p>
                            <CaseStudyInformation subTitle={"Smart integrations"} />
                            <p className="mt-5">
                                Gallabox’s plug-and-play integrations enabled MrMed.in to connect its WhatsApp workflows with their existing CRMs and support tools. This created a
                                streamlined backend ecosystem, cutting down data silos and manual data transfers.
                            </p>
                            <p className="mt-5">These goals were all met with the powerful suite of features like chatbots, shared team inbox, broadcasts, and automated flows.</p>
                        </section>

                        <section id="Impact">
                            <CaseStudyInformation subTitle={"The results"} />
                            <p>Since onboarding with Gallabox, MrMed has seen a tangible boost in their metrics:</p>

                            <FeatureList
                                List={[
                                    { listItem: "30% increase in both lead generation and customer base" },
                                    { listItem: "15% increase in employee productivity" },
                                    { listItem: "30% boost in customer satisfaction" },

                                    { listItem: "10% improvement in conversion rate for first-time customers" },
                                ]}
                                className="mt-5 bg-gray-100"
                            />

                            <CaseStudyInformation subTitle={"Final thoughts"} />

                            <p className="my-5">Laksh rates Gallabox a 10/10 when it comes to recommending it to others:</p>

                            <ClientFeedback
                                descriptions={
                                    <p className="text-gray-900 italic font-semibold px-6 mb-4">
                                        &quot;Gallabox helped us go from limitations to possibilities. It’s now a core part of our customer operations.&quot;
                                    </p>
                                }
                                designationWithServiceName="- Laksh Chhajer, Founder’s Office, MrMed"
                                className="border-blue-500 bg-blue-100  "
                            />
                        </section>
                    </div>
                </div>
                <div>
                    <div style={{ position: "sticky", top: "100px", minHeight: "510px" }} className="hidden md:block">
                        <Navbar links={navLinks} />
                    </div>
                </div>
            </section>
            <div className="max-w-6xl mx-auto text-center md:text-left">
                <section>
                    <h3 className="text-gray-900 max-w-6xl mx-auto mb-10 mt-5 text-center md:text-left">Check out other customer stories</h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto gap-10 mb-20">
                        {casestudyCards.slice(0, 3)?.map((data, index) => (
                            <CasestudyCard key={index} {...data} />
                        ))}
                    </div>
                </section>
            </div>
        </NewLayout>
    );
};

export default Mrmed;
